import React, { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import {
  RedirectAuthenticatedUser,
  RequireAdmin,
  RequireAuth,
  WebsiteBuilderRoute,
  WebsiteViewerRoute,
} from './RouteGuards';
import Home from '../../pages/Home';
import OnlineInvitations from '../../pages/OnlineInvitations';
import { ROUTE_PATHS } from './routePaths';

const Login = lazy(() => import('../../components/auth/Login'));
const ForgotPassword = lazy(() => import('../../components/auth/ForgotPassword'));
const Register = lazy(() => import('../../components/auth/Register'));
const AdminPanel = lazy(() => import('../../components/admin/AdminPanel'));
const Dashboard = lazy(() => import('../../pages/Dashboard'));

function SuspenseWrapper({ children }) {
  return (
    <Suspense fallback={<div className="page-loading"><div className="spinner" /></div>}>
      {children}
    </Suspense>
  );
}

function AppRoutes() {
  return (
    <Routes>
      <Route path={ROUTE_PATHS.home} element={<Home />} />

      <Route
        path={ROUTE_PATHS.login}
        element={
          <SuspenseWrapper>
            <RedirectAuthenticatedUser>
              <Login />
            </RedirectAuthenticatedUser>
          </SuspenseWrapper>
        }
      />
      <Route
        path={ROUTE_PATHS.register}
        element={
          <SuspenseWrapper>
            <RedirectAuthenticatedUser>
              <Register />
            </RedirectAuthenticatedUser>
          </SuspenseWrapper>
        }
      />
      <Route
        path={ROUTE_PATHS.forgotPassword}
        element={
          <SuspenseWrapper>
            <RedirectAuthenticatedUser>
              <ForgotPassword />
            </RedirectAuthenticatedUser>
          </SuspenseWrapper>
        }
      />

      <Route
        path={ROUTE_PATHS.dashboard}
        element={
          <SuspenseWrapper>
            <RequireAuth>
              <Dashboard />
            </RequireAuth>
          </SuspenseWrapper>
        }
      />
      <Route
        path={ROUTE_PATHS.admin}
        element={
          <SuspenseWrapper>
            <RequireAdmin>
              <AdminPanel />
            </RequireAdmin>
          </SuspenseWrapper>
        }
      />
      <Route
        path={ROUTE_PATHS.builder}
        element={
          <SuspenseWrapper>
            <RequireAuth>
              <WebsiteBuilderRoute />
            </RequireAuth>
          </SuspenseWrapper>
        }
      />
      <Route
        path={ROUTE_PATHS.builderWithId}
        element={
          <SuspenseWrapper>
            <RequireAuth>
              <WebsiteBuilderRoute />
            </RequireAuth>
          </SuspenseWrapper>
        }
      />
      <Route
        path={ROUTE_PATHS.siteViewer}
        element={
          <SuspenseWrapper>
            <WebsiteViewerRoute />
          </SuspenseWrapper>
        }
      />

      <Route
        path={ROUTE_PATHS.onlineInvitations}
        element={<OnlineInvitations />}
      />

      <Route
        path={ROUTE_PATHS.fallback}
        element={<Navigate to={ROUTE_PATHS.home} replace />}
      />
    </Routes>
  );
}

export default AppRoutes;
